<app-ice-stepper
  #stepper
  [hasCustomNavigation]="false"
  [interactedSteps]="Array.from(interactedSteps)"
  (isFinished)="submitForm.emit(registerMobilbytteForm)"
  (selectedIndexChange)="interactedSteps.add($event)"
  (selectionChange)="onStepChange($event)"
>
  @if (!!registerMobilbytteForm) {
    <cdk-step label="Sjekk IMEI" [completed]="checkIMEIForm.valid" [hasError]="checkIMEIForm.invalid">
      <app-check-imei-step
        [formGroup]="checkIMEIForm"
        (howToFindIMEIInquired)="
          lastInfoKey[0] = $event ? SanityInformationKeys.HowToFindIMEI : null; infoClicked.emit(lastInfoKey[0])
        "
      />
      <div class="step-navigation">
        <app-ice-button color="secondary" testId="mobilbytte-bytte-next-button" (click)="stepper.next()">
          Neste
        </app-ice-button>
      </div>
    </cdk-step>

    <cdk-step label="Tilstand" [completed]="conditionForm.valid" [hasError]="conditionForm.invalid">
      <app-condition-step
        [damageReasons]="damageReasons"
        [formGroup]="conditionForm"
        (phoneHasDamageInquired)="
          lastInfoKey[1] = $event ? SanityInformationKeys.DamageTypesDescriptions : null; infoClicked.emit(lastInfoKey[1])
        "
      />
      <ng-container *ngTemplateOutlet="stepperNavigation" />
    </cdk-step>

    <cdk-step
      label="Oppsummering"
      [completed]="hasInsurance() ? true : assessmentInsuranceForm.valid"
      [hasError]="hasInsurance() ? false : assessmentInsuranceForm.invalid"
    >
      <app-summary-step
        [formGroup]="assessmentInsuranceForm"
        [isPhoneDamaged]="isPhoneDamaged"
        [summaryRows]="summaryRows"
      />
      <ng-container *ngTemplateOutlet="stepperNavigation" />
    </cdk-step>

    @if (hasInsurance()) {
      @if (isPhoneDamaged) {
        <cdk-step
          label="Forsikring"
          [completed]="assessmentInsuranceForm.valid"
          [hasError]="assessmentInsuranceForm.invalid"
        >
          <app-insurance-step
            [formGroup]="assessmentInsuranceForm"
            (whatIsAnApprovedServicePointInquired)="
              lastInfoKey[3] = $event ? SanityInformationKeys.WhatIsAnApprovedServicePoint : null;
              infoClicked.emit(lastInfoKey[3])
            "
          />
          <ng-container *ngTemplateOutlet="stepperNavigation" />
        </cdk-step>
      } @else {
        <cdk-step
          label="Sammendrag"
          [completed]="assessmentInsuranceForm.valid"
          [hasError]="assessmentInsuranceForm.invalid"
        >
          <app-assessment-step
            [formGroup]="assessmentInsuranceForm"
            (whatIsAnApprovedServicePointInquired)="
              lastInfoKey[3] = $event ? SanityInformationKeys.WhatIsAnApprovedServicePoint : null;
              infoClicked.emit(lastInfoKey[3])
            "
          />
          <ng-container *ngTemplateOutlet="stepperNavigation" />
        </cdk-step>
      }
    }

    <cdk-step label="Betingelser" [completed]="termsForm.valid" [hasError]="termsForm.invalid">
      <app-terms-step [formGroup]="termsForm" [isPhoneDamaged]="isPhoneDamaged" />
      <div class="step-navigation">
        @if (isLoadingMobilBytteBytteRegistration()) {
          <app-spinner />
        } @else {
          <app-ice-button
            color="primary"
            testId="mobilbytte-bytte-submit-button"
            [disabled]="registerMobilbytteForm.invalid"
            (click)="stepper.isFinished.emit(true)"
          >
            Legg til i handlekurv
          </app-ice-button>
        }
      </div>
    </cdk-step>
  }
</app-ice-stepper>

<ng-template #stepperNavigation>
  <div class="step-navigation">
    <app-ice-button color="outlined" testId="mobilbytte-bytte-previous-button" (click)="stepper.previous()">
      Tilbake
    </app-ice-button>
    <app-ice-button color="secondary" testId="mobilbytte-bytte-next-button" (click)="stepper.next()">Neste</app-ice-button>
  </div>
</ng-template>
